<app-back-to-integrations-button></app-back-to-integrations-button>
<div class="page-content">
	<div>
		<img src="/assets/images/integrations/stewart-title-logo.svg" />
	</div>
	<div>
		<h2>Stewart Title</h2>
		<p class="mt-5">
			Order title insurance from Stewart Title from within Closer.
		</p>
		<div class="flex mt-5 gap-5 items-center">
			<app-button
				btn="primary"
				*ngIf="!connected && !loading"
				(click)="oauthConnect()"
				size="small"
				>Connect</app-button
			>
			<div *ngIf="loading">
				<app-icon [spin]="true" [icon]="ICON.LOADING"></app-icon>
			</div>
			<div class="flex items-center gap-2" *ngIf="connected && !loading">
				<div class="w-2 h-2 bg-green rounded-full"></div>
				<span class="text-green" *ngIf="connected">Connected</span>
			</div>

			<div *ngIf="profileId" class="flex gap-2">
				<span>Profile ID: </span>
				<span class="font-bold">{{ profileId }}</span>
			</div>
		</div>
		<div class="flex gap-5 mt-3">
			<app-button
				btn="primary"
				*ngIf="connected"
				(click)="oauthConnect()"
				size="small"
			>
				Re-validate credentials
			</app-button>

			<app-button btn="secondary" (click)="manageProfileIds()" size="small"
				>Manage profile IDs</app-button
			>
		</div>
		<app-profile-benefits [benefits]="benefits"></app-profile-benefits>
	</div>
	<div>
		<app-container title="Stewart Title resources" type="dark">
			<div class="text-sm flex flex-col gap-2">
				<a
					class="flex gap-2"
					externalNavInterceptor
					[href]="stewartNextStepsHomepageUrl"
					target="_blank"
					title="Home & toots"
				>
					<app-icon [icon]="ICON.PROPERTY"></app-icon>
					<div class="flex flex-col">
						<span class="font-bold">Home & tools</span>
						<span class="text-gray-400">Visit the NextSTEPS homepage</span>
					</div>
				</a>
				<a
					class="flex gap-2"
					externalNavInterceptor
					[href]="stewartCalculateQuoteUrl"
					target="_blank"
					title="Premium calculator"
				>
					<app-icon [icon]="ICON.CALCULATOR"></app-icon>
					<div class="flex flex-col">
						<span class="font-bold">Premium calculator</span>
						<span class="text-gray-400"
							>Quickly calculate a quote from Stewart Title</span
						>
					</div>
				</a>
				<a
					class="flex gap-2"
					externalNavInterceptor
					[href]="stewartOrderCommercialPropertyUrl"
					target="_blank"
					title="Order commercial policy"
				>
					<app-icon [icon]="ICON.FILE_DOWNLOAD"></app-icon>
					<div class="flex flex-col">
						<span class="font-bold">Order commercial policy</span>
						<span class="text-gray-400"
							>Order your commercial policy from Stewart Title</span
						>
					</div>
				</a>
				<a
					class="border-t-2 border-grey-lighter pt-4 m-2 flex flex-col items-center"
					externalNavInterceptor
					[href]="stewartEnrolmentUrl"
					target="_blank"
					title="Enroll now"
				>
					<p>New to Stewart Title?</p>
					<app-button [icon]="ICON.EXTERNAL" size="small"
						>Enroll now</app-button
					>
				</a>
			</div>
		</app-container>
		<div
			class="rounded-md border border-grey-lighter w-96 max-w-fit mt-8 bg-white"
		>
			<div class="flex justify-between items-center m-5">
				<p class="text-2xl font-bold">Contact info</p>
				<app-icon
					*ngIf="contact"
					[icon]="ICON.EDIT"
					class="text-lg cursor-pointer"
					(click)="openContactInfo()"
				></app-icon>
			</div>
			<div
				class="flex gap-2 ml-2 items-center my-5 font-bold p-5 cursor-pointer"
				(click)="openContactInfo()"
				*ngIf="!contact"
			>
				<app-icon [icon]="ICON.ADD"></app-icon>
				<p>Add main contact</p>
			</div>
			<div *ngIf="contact" class="px-5">
				<p class="font-bold text-lg">{{ contact.name }}</p>
				<p class="text-grey-lighter text-xs">{{ contact.title }}</p>
				<div class="text-sm flex flex-col gap-2 mb-4">
					<div class="flex gap-2" *ngIf="contact.phone">
						<app-icon class="text-grey-lighter" [icon]="ICON.PHONE"></app-icon>
						<p>{{ contact.phone }}</p>
					</div>
					<div class="flex gap-2" *ngIf="contact.email">
						<app-icon class="text-grey-lighter" [icon]="ICON.EMAIL"></app-icon>
						<p>{{ contact.email }}</p>
					</div>
				</div>
			</div>
			<hr class="w-full my-4 text-grey-lighter" />
			<div class="flex gap-2 px-5 mb-2">
				<app-icon class="text-green" [icon]="ICON.BUILDING"></app-icon>
				<p class="font-bold">Stewart Title Insurance Company</p>
			</div>
			<div class="text-sm px-5 flex flex-col gap-2 mb-4">
				<div class="flex gap-2">
					<app-icon class="text-grey-lighter" [icon]="ICON.LOCATION"></app-icon>
					<p>
						Royal Bank Plaza, North Tower 200 Bay Street, Suite 2600, Toronto,
						ON M5J 2J2
					</p>
				</div>
				<div class="flex gap-2">
					<app-icon class="text-grey-lighter" [icon]="ICON.PHONE"></app-icon>
					<p>(866) 969-9101</p>
				</div>
				<div class="flex gap-2">
					<app-icon class="text-grey-lighter" [icon]="ICON.FAX"></app-icon>
					<p>(888) 667-5151</p>
				</div>
			</div>
		</div>
	</div>
</div>
